<app-feature-hero
    variant="ims"
    title="Cloud Monitoring"
    description="Improve Cloud infrastructure health with easy-to-deploy cloud monitoring solutions."
    image=""
    imageAlt=""
></app-feature-hero>


<section class="container section-spacing">
    <div class="row mx-0 align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">Gain complete IT control with our cloud monitoring tools</h2>
                <p class="section-paragraph">Infraon ITIM provides integrated cloud-based VMs and software that makes it
                    tremendously easy to monitor cloud services - private and public like AWS, Google, Azure, etc., PaaS
                    services, applications, ports, URLs, etc. Get a bird’s eye view of your end-to-end IT infrastructure
                    with a dashboard-driven, real-time alerting system.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-img-right justify-content-center">
                <img src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/itim-cloud-monitoring-main-feature-01.png"
                    width="80%" alt="Gain complete IT control with our cloud monitoring tools">
            </div>
        </div>
    </div>
</section>


<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Key Feature</h2>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/cloud-01.svg"
                    alt="hybrid cloud">
            </div>
            <p class="section-title-s">Cloud IT Infrastructure Monitoring</p>
            <p class="section-paragraph-s">Get full control over your cloud ecosystem, including VMs apps, networks,
                servers, etc., with deep visibility into every nook and corner.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/alert.svg"
                    alt="Alert icon">
            </div>
            <p class="section-title-s">Cloud IT Event Monitoring</p>
            <p class="section-paragraph-s">Use a real-time detection system to monitor IT events as they happen with
                automated alerting, logging, reporting, and compliance.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/alert-octagon.svg"
                    alt="alert icon 2">
            </div>
            <p class="section-title-s">Cloud IT Fault & Incident Monitoring</p>
            <p class="section-paragraph-s">Deploy a single cloud-based command center to monitor IT-related issues and
                discover, customize, or share fault and incident analysis.</p>
        </div>
    </div>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/command-small.svg"
                    alt="Mcbook Command key">
            </div>
            <p class="section-title-s">Cloud API Monitoring</p>
            <p class="section-paragraph-s">Improve API availability & performance by rapidly validating data before
                monitoring relevant trends and patterns to avoid outages.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/reload.svg"
                    alt="reload icon">
            </div>
            <p class="section-title-s">Cloud IT SLA Monitoring</p>
            <p class="section-paragraph-s">Keep track of your IT SLA lifecycles across apps, networks, and servers with
                a customizable engine to establish escalation/routing rules.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/monitor.svg"
                    alt="Monitor screen">
            </div>
            <p class="section-title-s">Cloud & URL Monitoring</p>
            <p class="section-paragraph-s">Monitor key URL metrics like DNS time or response speed to increase the
                availability of your critical webpages.</p>
        </div>
    </div>
</section>


<section class="bg-grey">
    <div class="container section-spacing">
        <div class="row mx-0 d-flex align-items-center position-relative bg-black-dots">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                <h2 class="section-title">Other Features</h2>

                <div class="row mx-0 px-0">
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">KPI Dashboards</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Report Exports</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Bulk Excel Import/Export</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Scheduled Reports</p>
                        </li>
                    </ul>
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Reports</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Roles</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Custom Alerts</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Customizable Fields</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box d-flex justify-content-center position-absolute"
                style="right: 0;bottom: 0;">
                <img src="/assets/img/feature-pages/infraon-ims/cloud-monitoring/woman-1.webp" class="w-60" alt="woman point at features">
            </div>
        </div>
    </div>
</section>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a [routerLink]="['/registration']" [queryParams]="{ type: 'trial' }" class="secondary-button bg-white">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container">
        <h2 class="section-title text-center">Related Content</h2>

        <div class="row mx-0">
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
                <div class="backlink-container bg-white p-5 h-100" style="border: 1px solid #0000001c;">
                    <p class="section-title-s text-start">
                        Application Monitoring
                    </p>
                    <a class="primary-color" routerLink="/itim-ims/features/application-monitoring">Know more</a>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
                <div class="backlink-container bg-white p-5 h-100" style="border: 1px solid #0000001c;">
                    <p class="section-title-s text-start">
                        Server Monitoring
                    </p>
                    <a class="primary-color" routerLink="/itim-ims/features/server-monitoring">Know more</a>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
                <div class="backlink-container bg-white p-5 h-100" style="border: 1px solid #0000001c;">
                    <p class="section-title-s text-start">
                        IT Network Monitoring
                    </p>
                    <a class="primary-color" routerLink="/itim-ims/features/it-network-monitoring">Know more</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>

<app-faqs [faqs]="faqs" [theme]="'nms-theme'"></app-faqs>